import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CircularWithValueLabel from './CircularWithValueLabel';
import ClientProvider from './client';
export default createDemo(import.meta.url, CircularWithValueLabel, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/circular-with-value-label/CircularWithValueLabel.tsx",
    "fileName": "CircularWithValueLabel.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport CircularProgress from '@mui/material/CircularProgress';\nimport type { CircularProgressProps } from '@mui/material/CircularProgress';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nfunction CircularProgressWithLabel(\n  props: CircularProgressProps & { value: number },\n) {\n  return (\n    <Box sx={{ position: 'relative', display: 'inline-flex' }}>\n      <CircularProgress\n        variant=\"determinate\"\n        aria-label=\"Upload photos\"\n        {...props}\n      />\n      <Box\n        sx={{\n          top: 0,\n          left: 0,\n          bottom: 0,\n          right: 0,\n          position: 'absolute',\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n      >\n        <Typography\n          variant=\"caption\"\n          component=\"div\"\n          sx={{ color: 'text.secondary' }}\n        >{`${Math.round(props.value)}%`}</Typography>\n      </Box>\n    </Box>\n  );\n}\n\nexport default function CircularWithValueLabel() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 0,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [progress, setProgress] = React.useState(10);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));\n    }, 800);\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return <CircularProgressWithLabel value={progress} />;\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 52,
        "focusedLines": 12,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport CircularProgress from '@mui/material/CircularProgress';\nimport type { CircularProgressProps } from '@mui/material/CircularProgress';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nfunction CircularProgressWithLabel(\n  props: CircularProgressProps & { value: number },\n) {\n  return (\n    <Box sx={{ position: 'relative', display: 'inline-flex' }}>\n      <CircularProgress\n        variant=\"determinate\"\n        aria-label=\"Upload photos\"\n        {...props}\n      />\n      <Box\n        sx={{\n          top: 0,\n          left: 0,\n          bottom: 0,\n          right: 0,\n          position: 'absolute',\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n      >\n        <Typography\n          variant=\"caption\"\n          component=\"div\"\n          sx={{ color: 'text.secondary' }}\n        >{`${Math.round(props.value)}%`}</Typography>\n      </Box>\n    </Box>\n  );\n}\n\nexport default function CircularWithValueLabel() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0,
          "dataFrameFocusTarget": ""
        },
        "  const [progress, setProgress] = React.useState(10);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));\n    }, 800);\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return <CircularProgressWithLabel value={progress} />;\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "const"
              ],
              " [",
              [
                "span",
                "pl-c1",
                "progress"
              ],
              ", ",
              [
                "span",
                "pl-c1",
                "setProgress"
              ],
              "] ",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              " ",
              [
                "span",
                "pl-smi",
                "React"
              ],
              ".",
              [
                "span",
                "pl-en",
                "useState"
              ],
              "(",
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              ");"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            "\n"
          ],
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "  ",
              [
                "span",
                "pl-smi",
                "React"
              ],
              ".",
              [
                "span",
                "pl-en",
                "useEffect"
              ],
              "(() ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "    ",
              [
                "span",
                "pl-k",
                "const"
              ],
              " ",
              [
                "span",
                "pl-c1",
                "timer"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              " ",
              [
                "span",
                "pl-c1",
                "setInterval"
              ],
              "(() ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "      ",
              [
                "span",
                "pl-en",
                "setProgress"
              ],
              "((",
              [
                "span",
                "pl-v",
                "prevProgress"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " (",
              [
                "span",
                "pl-smi",
                "prevProgress"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                ">="
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "100"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "?"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-smi",
                "prevProgress"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "+"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              "));"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "    }, ",
              [
                "span",
                "pl-c1 di-num",
                "800"
              ],
              ");"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "    ",
              [
                "span",
                "pl-k",
                "return"
              ],
              " () ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "      ",
              [
                "span",
                "pl-c1",
                "clearInterval"
              ],
              "(",
              [
                "span",
                "pl-smi",
                "timer"
              ],
              ");"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            "    };"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            "  }, []);"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 50
            },
            "\n"
          ],
          [
            "span",
            "line",
            {
              "dataLn": 51
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "return"
              ],
              " <",
              [
                "span",
                "pl-c1 di-jsx",
                "CircularProgressWithLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "progress"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />;"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 52,
    "focusedLines": 12,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/CircularProgress",
      "@mui/material/Typography",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
